import { adminClient as apolloClient } from '@/store/apollo';

import ValidateCodeGql from '@/extensions/shop/store/graphql/queries/ValidateCouponCode.gql';

import CouponGql from '@/extensions/shop/store/graphql/queries/Coupon.gql';
import CouponsPaginatedGql from '@/extensions/shop/store/graphql/queries/CouponsPaginated.gql';
import CreateCouponGql from '@/extensions/shop/store/graphql/mutations/CreateCoupon.gql';
import UpdateCouponGql from '@/extensions/shop/store/graphql/mutations/UpdateCoupon.gql';
import DeleteCouponGql from '@/extensions/shop/store/graphql/mutations/DeleteCoupon.gql';

export default {
    validateCode: (code, shopID = null, excludedCouponID = null) =>
        new Promise((resolve, reject) => {
            let variables = { code };
            if (shopID) variables.shop = parseInt(shopID);
            if (excludedCouponID) variables.excludedCoupon = parseInt(excludedCouponID);

            apolloClient
                .query({
                    query: ValidateCodeGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.CO_ValidateCouponCode))
                .catch(err => reject(err));
        }),
    fetchCouponsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CouponsPaginatedGql,
                    variables: {
                        scope: _.get(data, 'scope', 'ex'),
                        type: _.get(data, 'type', 'shop_coupon'),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'id'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/coupon/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.CO_CouponsPaginated))
                .catch(err => reject(err));
        }),
    fetchCoupon: variables => {
        if (variables.id) variables.id = parseInt(variables.id);
        if (variables.customer) variables.customer = parseInt(variables.customer);
        if (variables.cms) variables.cms = parseInt(variables.cms);

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CouponGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_Coupon))
                .catch(err => reject(err));
        });
    },
    create: coupon => {
        if (coupon === undefined) throw new Error('required argument is missing');

        coupon = _.removeDeepByKey(coupon, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCouponGql,
                    variables: { coupon }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_CreateCoupon);
                })
                .catch(err => reject(err));
        });
    },
    update: coupon => {
        if (coupon === undefined) throw new Error('required argument is missing');

        coupon = _.removeDeepByKey(coupon, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateCouponGql,
                    variables: { coupon }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_UpdateCoupon);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCouponGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteCoupon);
                })
                .catch(err => reject(err));
        });
    },
    noDeleteDialog: (value) => {
        if (value !== undefined) {
            localStorage.setItem('no-delete-dialog:coupon', value);
        } else {
            return localStorage.getItem('no-delete-dialog:coupon');
        }
    },
};
